import { faBuilding } from "@fortawesome/pro-regular-svg-icons/faBuilding";
import { Formik } from "formik";
import PropTypes from "prop-types";
import React, { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import Card from "reactstrap/es/Card";
import CardBody from "reactstrap/es/CardBody";
import Col from "reactstrap/es/Col";
import Row from "reactstrap/es/Row";

// App
import {
  ButtonCancel,
  ButtonSave,
  ContentBody,
  ContentErrors,
  ContentHeader,
  ContentHeaderButtons,
  ContentHeaderTitle,
  Error403,
} from "../../core/components";
import { FormikForm } from "../../core/components/formik";
import { ROUTE_ORGANIZATION } from "../../../constants";

// Auth
import { usePermission } from "../../auth/hooks/usePermission";

// Organization
import { formClear, formInit, formSubmitCreate } from "../actions/organization";
import { OrganizationFieldset } from "../components";

const OrganizationPageAdd = (props) => {
  const { formDataParents, formErrors, formIsSubmitting, history } = props;
  const [hasPermission] = usePermission();
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t("title.organizations");

    props.formInit();

    return () => {
      props.formClear();
    };
  }, []);

  const handleSubmit = (values) => {
    props.formSubmitCreate(values).then(() => {
      if (0 === props.formErrors.length) {
        history.push(ROUTE_ORGANIZATION);
      }
    });
  };

  // Kontrola opravneni
  if (!hasPermission("organization.create")) {
    return <Error403 />;
  }

  return (
    <Fragment>
      <ContentHeader>
        <ContentHeaderTitle icon={faBuilding} title={t("title.organizations")} />
        <ContentHeaderButtons>
          <ButtonSave
            disabled={formIsSubmitting}
            executing={formIsSubmitting}
            form="form-organizations"
            text={t("action.save")}
          />
          <ButtonCancel text={t("action.cancel")} to={ROUTE_ORGANIZATION} />
        </ContentHeaderButtons>
      </ContentHeader>

      <ContentErrors errors={formErrors} />

      <ContentBody>
        <Formik
          initialValues={{
            idParent: "",
            name: "",
          }}
          onSubmit={handleSubmit}
          render={(formik) => (
            <FormikForm id="form-organizations" onSubmit={formik.handleSubmit}>
              <Row>
                <Col>
                  <Card>
                    <CardBody>
                      <OrganizationFieldset formDataParents={formDataParents} />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </FormikForm>
          )}
        />
      </ContentBody>
    </Fragment>
  );
};

OrganizationPageAdd.propTypes = {
  formClear: PropTypes.func.isRequired,
  formData: PropTypes.object.isRequired,
  formDataParents: PropTypes.array.isRequired,
  formErrors: PropTypes.array.isRequired,
  formInit: PropTypes.func.isRequired,
  formIsSubmitting: PropTypes.bool.isRequired,
  formSubmitCreate: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  formClear,
  formInit,
  formSubmitCreate,
};

const mapStateToProps = (state) => ({
  formData: state.organization.formData,
  formDataParents: state.organization.formDataParents,
  formErrors: state.organization.formErrors,
  formIsSubmitting: state.organization.formIsSubmitting,
});

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationPageAdd);
